// @ts-nocheck
import React from 'react';
import { Input, Grid, AtsTip, SectionCard, AddButton, FormNav, Checkbox } from '../FormField';
import { ATS_TIPS } from '../../data/initialData';


export default function EducationTab({ data, onChange, onBack, onNext }) {
  const update = (idx, key, val) => {
    const arr = [...data];
    arr[idx] = { ...arr[idx], [key]: val };
    onChange(arr);
  };

  const add = () =>
    onChange([
      ...data,
      {
        id: Date.now(),
        school: '',
        degree: '',
        field: '',
        gpa: '',
        percentage: '',
        startYear: '',
        endYear: '',
        current: false,
        courses: '',
        honors: '',
      },
    ]);

  const remove = (idx) => onChange(data.filter((_, i) => i !== idx));

  return (
    <div>
      {/* <AtsTip {...ATS_TIPS.education} /> */}

      {data.map((ed, i) => (
        <SectionCard
          key={ed.id}
          title="Education"
          index={i}
          showRemove={data.length > 1}
          onRemove={() => remove(i)}
        >
          <Input
            label="School / University"
            required
            value={ed.school}
            onChange={(v) => update(i, 'school', v)}
            placeholder="Indian Institute of Technology, Hyderabad"
          />
          <Grid cols={2}>
            <Input
              label="Degree"
              value={ed.degree}
              onChange={(v) => update(i, 'degree', v)}
              placeholder="B.Tech"
            />
            <Input
              label="Field of Study"
              value={ed.field}
              onChange={(v) => update(i, 'field', v)}
              placeholder="Computer Science & Engineering"
            />
          </Grid>
          <Grid cols={4}>
            <Input
              label="Start Year"
              value={ed.startYear}
              onChange={(v) => update(i, 'startYear', v)}
              placeholder="2021"
            />
            <Input
              label="End Year"
              value={ed.endYear}
              onChange={(v) => update(i, 'endYear', v)}
              placeholder="2025"
              disabled={ed.current}
            />
            <Input
              label="GPA"
              hint="if applicable"
              value={ed.gpa}
              onChange={(v) => update(i, 'gpa', v)}
              placeholder="9.8 / 10"
            />
            <Input
              label="Percentage"
              hint="if applicable"
              value={ed.percentage}
              onChange={(v) => update(i, 'percentage', v)}
              placeholder="98%"
            />
          </Grid>
          <Checkbox
  label="Currently enrolled"
  checked={ed.current}
  onChange={(v) => update(i, 'current', v)}
/>
          <Input
            label="Relevant Coursework"
            hint="comma-separated"
            value={ed.courses}
            onChange={(v) => update(i, 'courses', v)}
            placeholder="Data Structures & Algorithms, Operating Systems, DBMS, Computer Networks, Machine Learning"
          />
          <Input
            label="Honors / Awards"
            value={ed.honors}
            onChange={(v) => update(i, 'honors', v)}
            placeholder="Dean's List (3 semesters), Merit Scholarship, JEE Advanced AIR 1245"
          />
        </SectionCard>
      ))}

      <AddButton onClick={add} label="Add Another Education" />

      <FormNav showBack onBack={onBack} showNext onNext={onNext} nextLabel="Next: Experience →" />
    </div>
  );
}
